<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    icon="fa-layer-group"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="stockCategoryForm" :labelColumnSize="3">
      <FormRow label="Name"><FormInputText placeholder="Name" v-model="stockCategory.name" field="name" /></FormRow>
      <FormRow label="Stock Type"><FormSelect v-model="stockCategory.stockType" field="stockType" :options="stockTypeOptions" /></FormRow>
      <FormRow label="Unit Of Measure" v-show="!stockTypeIsTemplate && !stockTypeIsGlass">
        <FormSelect placeholder="Unit of measure" v-model="stockCategory.uomType" field="uomType" :options="stockUOMTypeOptions" />
      </FormRow>
      <FormRow label="Parent Category" v-if="isRootCategory"><span class="col-form-label">Root Category</span></FormRow>
      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'
import { InventoryStockTypes, InventoryStockTypeLookup, UOMTypes, UOMTypeLookup } from '@/store/types'

export default {
  name: "StockCategoryDialog",
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    isCreateMode: Boolean,
    parentCategoryId: Number,
    stockType: String
  },
  data() {
    return {
      stockCategoryId: null,
      stockCategory: {},
      stockCategoryForm: {},
      stockCategoryList: [],
      stockCategoryListLoading: false,
      submitting: false,
      stockTypeOptions: InventoryStockTypeLookup
    }
  },
  mounted() {
    this.stockCategoryListLoading = true

    this.$apiService.inventoryService.getStockCategoryList()
    .then(list => {

      this.stockCategoryList = _.concat(
        [{ value: null, name: 'None' }],
        list.data.map(stockCategoryInfo => {
          return {
            value: stockCategoryInfo.id,
            name: stockCategoryInfo.name
          }
        })
      )
    })
    .finally(() => {
      this.stockCategoryListLoading = false
    })
  },
  computed: {
    stockTypeIsGlass() { return this.stockCategory.stockType == InventoryStockTypes.glass },
    stockTypeIsGlassService() { return this.stockCategory.stockType == InventoryStockTypes.glassService },
    stockTypeIsTemplate() { return this.stockCategory.stockType == InventoryStockTypes.template },
    stockTypeIsGeneral() { return this.stockCategory.stockType == InventoryStockTypes.general },
    stockTypeIsAssembly() { return this.stockCategory.stockType == InventoryStockTypes.assembly },

    stockUOMTypeOptions() {
      // Ignore certain UOM types not applicable to inventory
      var unavailableTypes = [UOMTypes.eachSubItem]
      return UOMTypeLookup.filter(lookup => !unavailableTypes.includes(lookup.value))
    },

    title() {
      return this.isCreateMode ? 'New Stock Category' : 'Edit Stock Category'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    },
    isRootCategory() {
      if(this.isCreateMode) {
        if(this.parentCategoryId == null)
          return true
      } else {
        if(this.stockCategory.parentCategoryId == null)
          return true
      }
      return false
    }

  },
  methods: {
    show(stockCategory) {
      // Reset form
      this.stockCategory = { }
      this.stockCategoryId = 0
      this.stockCategoryForm = {}
      this.submitting = false

      if(stockCategory != null) {
        this.stockCategory = _.cloneDeep(stockCategory)
        this.stockCategoryId = stockCategory.id
      }
      if(this.$props.stockType != null) {
        this.stockCategory.stockType = this.$props.stockType
      }

      // Force UoM for stock types
      if(this.stockTypeIsGlass)
        this.stockCategory.uomType = UOMTypes.metresq
      if(this.stockTypeIsTemplate)
        this.stockCategory.uomType = null

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var stockCategoryData = _.cloneDeep(this.$data.stockCategory)
      stockCategoryData.parentCategoryId = this.$props.parentCategoryId

      if(this.isCreateMode) {
        this.$apiService.inventoryService.createStockCategory(stockCategoryData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.stockCategoryForm = this.processFormResponse(err)
        })
      } else {
        stockCategoryData = _.omit(stockCategoryData, 'parentCategoryId')

        this.$apiService.inventoryService.updateStockCategory(this.stockCategoryId, stockCategoryData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.stockCategoryForm = this.processFormResponse(err)
        })
      }
    }
  }
}
</script>